<template>
  <div class="cardInfo">
    <span class="cardInfo--row">カード番号</span>
    <span>{{ cardNumber | cardNumberFormat}}</span>
    <span class="cardInfo--row">カード有効期限</span>
    <span>{{ cardExpiration | cardExpirationFormat}}</span>
  </div>
</template>

<script>
export default {
  name: "CardInfo",
  props: {
    cardNumber: {
      type: String,
      default:''
    },
    cardExpiration: {
      type: String,
      default: ''
    },
  },
  methods: {

  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.cardInfo{
  padding: 15px 20px;
  display: grid;
  grid-template-rows: 30px 30px;
  grid-template-columns: 120px 1fr;
  font-size: 14px;
  align-items: center;
  &--row{
    font-size: 12px;
    color: $col_temp_gray6
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/CardInfo.vue